export const GET_PAYMENTS_BY_DOC_HEADER = "GET_PAYMENTS_BY_DOC_HEADER"
export const SET_PAYMENTS_QUERY = "SET_PAYMENTS_QUERY"